import React from 'react';
import styled, { css } from 'styled-components';
import { media } from '@peloton/styles';
import { backgroundGray, white } from '@engage/colors';
import { getAppliedFilterCount } from '@engage/filters';
import { useReduxState } from '@engage/redux';
import { spaces } from '@engage/styles';
import { Button5Large } from '@members/buttons';
import { SearchBar } from '../SearchBar';
import FilterButtonContent from './FilterButtonContent';

export const FilterRow: React.FC<
  React.PropsWithChildren<{ toggleAction: () => void }>
> = ({ toggleAction }) => {
  const appliedFilterCount = useReduxState(getAppliedFilterCount);

  return (
    <Container>
      <SearchBar />
      <RightContainer>
        <FilterButton
          data-test-id="filterButton"
          onClick={toggleAction}
          id="filterButton"
        >
          <FilterButtonContent appliedFilterCount={appliedFilterCount} />
        </FilterButton>
      </RightContainer>
    </Container>
  );
};

const filterButtonStyles = css`
  display: none;
  margin-left: ${spaces.medium}px;

  ${media.tablet`
    display: block;
    min-width: 138px;
  `}
`;

const FilterButton = styled(Button5Large)`
  ${filterButtonStyles}
  background-color: ${white}
`;

const Container = styled.div`
  align-items: center;
  background-color: ${backgroundGray};
  display: flex;
  justify-content: space-between;
  margin: auto;
  padding: 13.5px 0;

  ${media.tabletXLarge`
    padding: 15px 0;
  `}
`;

const RightContainer = styled.div`
  display: flex;
  align-items: center;
`;
